<template>
	<div class="cruise-search">
		<div>
			<filters v-if="showFilters"></filters>
			<div ref="results">
				<results :max-results="maxResults" :promotional-results="promotionalRoutesResult" :embedded="embedded" @scrollToTop="$refs.results.scrollIntoView()"></results>
				<div class="no-results-message" v-if="results.length === 0 && !loading">
					Please contact our Polar Specialists on 0203 196 1000
				</div>
			</div>
		</div>
		<div class="loading-message" v-if="loading">
			Updating Search Results...
		</div>
	</div>
</template>

<script>
import Filters from './Filters';
import Results from './Results';

export default {
	props: {
		showFilters: {
			type: String,
			default: 'true'
		},
		maxResults: {
			type: String,
			default: '1000'
		},
		promoteRoutes: {
			type: Array,
			required: false,
			default: () => [300],
		},
		embedded: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		results: function () {
			return this.$store.getters.results.slice(0, this.maxResults);
		},
		loading: function () {
			return this.$store.getters.loading;
		},
		promotionalRoutesResult() {
			if (this.promoteRoutes.length > 0)
			{
				let results = [];
				for (let i = 0; i < this.promoteRoutes.length; i++)
				{
					let result = this.$store.getters.results.find(({cruises}) => cruises.find(({route}) => route.id === this.promoteRoutes[i]));
					if (typeof result !== 'undefined')
						results.push(result);
				}
				return results;
			}

			return [];
		},
	},
	components: {
		Filters,
		Results,
	}
}
</script>

<style lang="scss" scoped>
.cruise-search {
	position: relative;
	min-height: 80px;
}

.no-results-message {
	color: red;
}

.loading-message {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.8);
	text-align: center;
	font-size: 200%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	z-index: 1;
}

@media (max-width: 767px) {
	.cruise-search {
		margin: 0 20px;
	}

	.filters {
		@supports ((position: sticky) or (position: -webkit-sticky))
		{
			position: sticky;
			position: -webkit-sticky;
			top: 90px;
		}
		padding: 10px;
		background: rgba(255, 255, 255, 0.8);
		z-index: 1;
	}
}
</style>
